import { HttpClient } from '@angular/common/http';
import { Base } from './base';

export class Campaigns extends Base {
  constructor(protected httpClient: HttpClient) {
    super(httpClient, 'campaigns');
  }

  getCompensationAvailable() {
    return this.api.get('compensation_available');
  }
}
